import React from "react";

function Health() {
  return (
    <>
      <span>Healthy</span>
    </>
  );
}

export default Health;
